// create a colored div for each subject

import axiosConfig from "../axios/config";
import {useEffect, useState} from "react";
import {Box, Button, Card, CardActions, CardContent, Checkbox, Grow} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';

const ToolSubmitTiles = (props) => {

    let {parentID, colors} = props;

    const [subjects, setSubjects] = useState([{}]);

    // let tileColors;
    // tileColors = {
    //     "strategic-issues": ["#10598c","#1b75bc","#00aeef","#2b839b","#10598c","#1b75bc","#39b2dc","#10598c","#469cd6","#2b839b"],
    //     "complexity": ["#148944","#30b451","#7bc476","#4aba76","#6caf5b","#3eaf58","#34af65"],
    //     "technical-building-blocks": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    //     "data-from-practice": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    //     "knowledge-from-data": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    //     "knowledge-into-practice": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    //     "it-technology-platforms": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    //     "communities": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    // };

    // retrieve subjects from AJAX call
    useEffect(() => {
        async function getData() {
            try {
                const response = await axiosConfig.get("/wp-json/lhstk/v1/visualnav/");
                // const response = await axios.get("https://lhstoolkit.learninghealthcareproject.co.uk/wp-json/lhstk/v1/visualnav");
                const subjects = response.data;
                setSubjects(subjects);
            } catch (error) {
                console.log('oups! something went wrong'+error);
            }          
        }

        getData();
    }, [])

    function titleCase(str) {
        return str.toLowerCase().split(' ').map(function(word) {
          return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            {subjects.filter(subject => subject.parent == 0).map((subjectLevel0, index0) => (
                <Grid 
                    container 
                    spacing={2} 
                    className="nav-tiles-wheel" 
                    alignItems="stretch"
                    sx={{display: 
                            subjectLevel0.term_id == parentID || 
                            subjectLevel0.slug == "technical-building-blocks" || 
                            subjectLevel0.slug == "communities"? 
                            "flex" : "none"
                        }}
                >   
                    {((subjectLevel0.slug != "technical-building-blocks" && subjectLevel0.slug != "communities") ||  ( subjectLevel0.slug != "technical-building-blocks" && subjects.find(subject => subject.term_id == parentID).slug == "developing-learning-communities")) &&
                        <Grid item xs={12} >
                            <h6 className="">{subjectLevel0.description}</h6>
                        </Grid>
                    }
                    {subjects.filter(subject => subject.parent == subjectLevel0.term_id).map((subjectLevel1, index1) => (
                        // if there are a second level of children (the case for building blocks), create a tile for each child
                        subjects.filter(subject => subject.parent == subjectLevel1.term_id).length > 0 ? (
                            <Grid 
                                container 
                                spacing={2} 
                                className="nav-tiles-wheel" 
                                alignItems="stretch"
                                sx={{display: subjectLevel1.term_id == parentID || subjectLevel1.term_id == subjects.find(subject => subject.term_id == parentID).parent ? "flex" : "none"}}
                            >
                                <Grid item xs={12} >
                                    {console.log("hasLevel2: ", subjects.filter(subject => subject.parent == subjectLevel1.term_id) )}
                                    <h6>{subjectLevel1.description}</h6>
                                </Grid>
                                {subjects.filter(subject => subject.parent == subjectLevel1.term_id).map((subjectLevel2, index2) => (                              
                                    <Grow in={true} timeout={100*index2}>
                                        <Grid 
                                            item
                                            // xs={12} sm={6} md={4} lg={3} xl={2}
                                            xs={12} sm={12} md={6} lg={4} xl={4}
                                            className="nav-tiles-wheel__tile"
                                            alignItems="stretch"
                                        >
                                            <label for={`usp-taxonomy-${subjectLevel2.taxonomy}-${subjectLevel2.term_id}`} style={{width: "100%"}} >
                                                <Card
                                                    className="nav-tiles-wheel__tile__card" alignItems="stretch"
                                                    sx ={{
                                                        backgroundColor: colors[subjectLevel0.slug][(index1+1)+(index2+1)-1],
                                                        height: "100%",
                                                        width: "100%",
                                                        borderRadius: 0,
                                                    }}
                                                >
                                                    <CardContent sx={{padding: "8px"}} >
                                                        <h6>{titleCase(subjectLevel2.name)}</h6>
                                                        <p>{subjectLevel2.description}</p>
                                                    </CardContent>
                                                    <CardActions sx={{padding: "8px"}} >
                                                        <Checkbox
                                                            id={`usp-taxonomy-${subjectLevel2.taxonomy}-${subjectLevel2.term_id}`}
                                                            name={`usp-taxonomy-${subjectLevel2.taxonomy}[]`}
                                                            value={subjectLevel2.term_id}
                                                        />
                                                    </CardActions>
                                                </Card>
                                            </label>
                                        </Grid>
                                    </Grow>
                                ))}
                            </Grid>
                            ):
                            <>
                                
                                <Grow in={true} timeout={100*index1}>
                                    <Grid 
                                        item 
                                        // xs={12} sm={6} md={4} lg={3} xl={2}
                                        xs={12} sm={12} md={6} lg={4} xl={4}
                                        className="nav-tiles-wheel__tile" 
                                        alignItems="stretch"
                                        sx={{display: subjectLevel0.term_id == parentID || subjectLevel1.term_id == parentID ? "flex" : "none"}}                    
                                    > 
                                        <label for={`usp-taxonomy-${subjectLevel1.taxonomy}-${subjectLevel1.term_id}`}  style={{width: "100%"}} >
                                            <Card 
                                                className="nav-tiles-wheel__tile__card"
                                                sx ={{
                                        
                                                    backgroundColor: colors[subjectLevel0.slug][index1],
                                                    height: "100%",
                                                    width: "100%",
                                                    borderRadius: 0,
                                                }}
                                                // onClick={() => window.location.href = toolkitData.root_url + "/subject/" + subject.slug}
                                            >
                                                <CardContent sx={{padding: "8px"}} >
                                                    <h6>{titleCase(subjectLevel1.name)}</h6>
                                                    <p>{subjectLevel1.description}</p>
                                                </CardContent>
                                                <CardActions>
                                                    <Checkbox 
                                                        name={`usp-taxonomy-${subjectLevel1.taxonomy}[]`} 
                                                        id={`usp-taxonomy-${subjectLevel1.taxonomy}-${subjectLevel1.term_id}`}
                                                        value={subjectLevel1.term_id}
                                                    />
                                                </CardActions>
                                                
                                            </Card>

                                        </label>

                                    </Grid>
                                </Grow>
                            </>
                    ))
                }
                </Grid>
            ))}
        </Box>
    );
}

export default ToolSubmitTiles;
